import { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import _debounce from 'lodash/debounce';

import { qaBackendApiInstance } from '../../config/config';

const mapOrientation = (orientation: string): string => {
  if (orientation === 'vertical') return 'portrait';
  if (orientation === 'horizontal') return 'landscape';
  return 'square';
};

export const fetchGettyImages = async (
  query: string,
  isFirstRequest: boolean,
  orientation: string,
  page_size: number,
  page: number
) => {
  const orientations = mapOrientation(orientation);
  const { data } = await qaBackendApiInstance.post('/stock-media/search-images', {
    searchQuery: query,
    page,
    orientations,
    page_size,
    isFirstRequest,
  });
  return data;
};

export const useGetGettyImages = (
  query = '',
  orientation: string,
  isFirstRequest: boolean,
  page_size: number,
  initialPage: number,
  debounceDelay = 500
) => {
  const [page, setPage] = useState(initialPage);
  const [debouncedQuery, setDebouncedQuery] = useState(query);

  const updateQuery = _debounce((newQuery: string) => {
    setDebouncedQuery(newQuery);
  }, debounceDelay);

  useEffect(() => {
    updateQuery(query);
  }, [query]);

  useEffect(() => {
    setPage(initialPage);
  }, [query, orientation, initialPage]);

  const result = useQuery(
    ['gettyImages', debouncedQuery, isFirstRequest, orientation, page_size, page],
    () => fetchGettyImages(debouncedQuery, isFirstRequest, orientation, page_size, page),
    {
      enabled: !!debouncedQuery,
      staleTime: 1000 * 60 * 5,
    }
  );

  return {
    data: result.data,
    error: result.error,
    isLoading: result.isLoading,
    isSuccess: result.isSuccess,
    page,
    setPage,
  };
};
